import {
  SIMDATA5G_COUNT_ASSIGN_SUCCESS,
  SIMDATA5G_HISTORY_LIST_SUCCESS,
  SIMDATA5G_IMPORT_SUCCESS,
  SIMDATA5G_LIST_SUCCESS,
  SIMDATA5G_NEW_CARE_SUCCESS,
  SIMDATA5G_ONE_SUCCESS,
  SIMDATA5G_UPDATE_FILTER,

  SIMDATA5G_UPDATE_HOMEPAGE_FILTER,
  SIMDATA5G_HOMEPAGE_LIST_SUCCESS,
  SIMDATA5G_HOMEPAGE_ONE_SUCCESS,

  SIMDATA5G_LIMIT_UPDATE_HOMEPAGE_FILTER,
  SIMDATA5G_LIMIT_HOMEPAGE_LIST_SUCCESS,
  SIMDATA5G_LIMIT_HOMEPAGE_ONE_SUCCESS,
} from 'src/actions/simdata5g.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageSimdata5gFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageSimdata5gPage: 0,
    homepageSimdata5gLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageSimdata5gLimitFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageSimdata5gLimitPage: 0,
    homepageSimdata5gLimitLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,

  homepageSimdata5gItems: [],
  homepageSimdata5gTotal: 0,
  homepageSimdata5gSelected: undefined,

  homepageSimdata5gLimitItems: [],
  homepageSimdata5gLimitTotal: 0,
  homepageSimdata5gLimitSelected: undefined,

  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const simdata5gReducer = (state = initState, action) => {
  switch (action.type) {
    case SIMDATA5G_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case SIMDATA5G_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case SIMDATA5G_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case SIMDATA5G_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageSimdata5gFilter !== 'undefined' && state.homepageSimdata5gFilter) {
        if (action.data.homepageSimdata5gPage == 'no_update' && typeof state.homepageSimdata5gFilter.homepageSimdata5gPage !== 'undefined') action.data.homepageSimdata5gPage = state.homepageSimdata5gFilter.homepageSimdata5gPage;
        if (action.data.homepageSimdata5gLimit == 'no_update' && typeof state.homepageSimdata5gFilter.homepageSimdata5gLimit !== 'undefined') action.data.homepageSimdata5gLimit = state.homepageSimdata5gFilter.homepageSimdata5gLimit;
      }
      return {
        ...state,
        homepageSimdata5gFilter: action.data,
      }
    }
    case SIMDATA5G_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageSimdata5gItems: action.data.homepageSimdata5gItems,
        homepageSimdata5gTotal: action.data.homepageSimdata5gTotal,
      }
    }
    case SIMDATA5G_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageSimdata5gSelected: action.data
      }
    }
    case SIMDATA5G_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageSimdata5gLimitFilter !== 'undefined' && state.homepageSimdata5gLimitFilter) {
        if (action.data.homepageSimdata5gLimitPage == 'no_update' && typeof state.homepageSimdata5gLimitFilter.homepageSimdata5gLimitPage !== 'undefined') action.data.homepageSimdata5gLimitPage = state.homepageSimdata5gLimitFilter.homepageSimdata5gLimitPage;
        if (action.data.homepageSimdata5gLimitLimit == 'no_update' && typeof state.homepageSimdata5gLimitFilter.homepageSimdata5gLimitLimit !== 'undefined') action.data.homepageSimdata5gLimitLimit = state.homepageSimdata5gLimitFilter.homepageSimdata5gLimitLimit;
      }
      return {
        ...state,
        homepageSimdata5gLimitFilter: action.data,
      }
    }
    case SIMDATA5G_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageSimdata5gLimitItems: action.data.homepageSimdata5gLimitItems,
        homepageSimdata5gLimitTotal: action.data.homepageSimdata5gLimitTotal,
      }
    }
    case SIMDATA5G_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageSimdata5gLimitSelected: action.data
      }
    }
    case SIMDATA5G_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case SIMDATA5G_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case SIMDATA5G_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case SIMDATA5G_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default simdata5gReducer